import React, { VFC } from 'react';
import T from 'i18n-react';

import PeopleTabs from '~/src/core/People/components/PeopleTabs';
import { Person } from '~/src/core/People/types';
import PersonTab from '~/src/core/People/components/PersonTab';
import RemarkTabPanel from './RemarkTabPanel';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 'bold',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(4),

    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  divider: {
    backgroundColor: '#000000',
  },
}));

interface Props {
  tabValue: number;
  people: Person[];
  onChangeTab: (id: number) => void;
  loaded: boolean;
}

const PeopleComponent: VFC<Props> = ({
  tabValue,
  people,
  onChangeTab,
  loaded,
}) => {
  const classes = useStyles();
  const handleChangeTab = (event, value) => onChangeTab(value);
  return (
    <>
      <Typography classes={{ root: classes.title }}>
        {T.translate('plan.people')}
      </Typography>
      <PeopleTabs
        tabValue={tabValue}
        selectedPeople={people}
        onChangeTab={handleChangeTab}
        loaded={loaded}
      >
        {people.map((person, index) => (
          <PersonTab
            key={person.id}
            person={person}
            loaded={loaded}
            onChangeTab={onChangeTab}
            index={index}
          />
        ))}
      </PeopleTabs>
      <Divider classes={{ root: classes.divider }} />
      {people.map((person, index) => (
        <RemarkTabPanel
          key={person.id}
          person={person}
          tabValue={tabValue}
          index={index}
        />
      ))}
    </>
  );
};

export default PeopleComponent;
